import React from 'react';
import { BASE_URL } from '../Api';

class ThankYou extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            link: `${BASE_URL}/releases/latest/Aronium.${props.version}.Setup.exe`,
            isPro: props.version === 'Pro'
        };
    }

    componentDidMount() {
        setTimeout(() => this.startDownload(), 1000);
    }

    startDownload() {
        const link = document.createElement('a');
        link.href = this.state.link;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    }

    render() {
        return <section className='max-w-screen-xl mx-auto text-center p-4'>
            <h1 className='text-5xl mt-8 tracking-tighter'>Thank you for downloading Aronium {this.props.version}!</h1>

            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" className="w-32 h-32 mx-auto mt-8 text-green-600">
                <path strokeLinecap="round" strokeLinejoin="round" d="M3 16.5v2.25A2.25 2.25 0 0 0 5.25 21h13.5A2.25 2.25 0 0 0 21 18.75V16.5M16.5 12 12 16.5m0 0L7.5 12m4.5 4.5V3" />
            </svg>

            <div className='my-8'>
                Your download will begin shortly. If it does not, please use the <a href={this.state.link}>direct download link</a>.
            </div>
            <hr className='md:w-48 mx-auto' />
            <h1 className='text-4xl my-8'>What's next?</h1>
            {this.state.isPro && <div className="my-8">
                <a href={`${BASE_URL}/documents/Aronium_Networking_Setup_Instructions.pdf`} target="_blank" rel="noreferrer" className="hover:no-underline inline-flex items-center justify-center px-5 py-3 mr-3 text-base font-medium text-center text-white rounded-full bg-primary-700 hover:bg-primary-800 focus:ring-4 focus:ring-primary-300 dark:focus:ring-primary-900">
                    <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 24 24" className="mr-4 w-6 h-6">
                        <path strokeLinecap="round" strokeLinejoin="round" d="M8.847 17.875c.191-.211.548-.431.801-.559-.152.3-.366.619-.544.792-.36.353-.556.095-.257-.233zm7.062-12.098c2.047-.478 4.805.28 6.091 1.179-1.494-1.997-5.23-5.708-7.432-6.882 1.156 1.168 1.563 4.235 1.341 5.703zm-4.769 10.21c.328-.109 1.036-.274 1.213-.315-.02-.021-.528-.544-.695-.832-.134.335-.509 1.127-.518 1.147zm.64-4.008c-.057-.278-.263-.299-.326.024-.057.296.029.771.129 1.061.113-.237.255-.805.197-1.085zm10.22-.979v13h-20v-24h8.409c4.857 0 3.335 8 3.335 8 3.009-.745 8.256-.42 8.256 3zm-6.98 4.413c-.526-.077-1.272.009-1.797.093-.385-.325-.866-.817-1.233-1.472.253-.652.415-1.168.483-1.536.354-1.919-1.979-2.072-1.729-.012.066.549.222 1.082.464 1.588-.286.709-.651 1.508-1.018 2.232-.811.307-1.396.627-1.742.954-1.212 1.143.295 2.661 1.438 1.014.274-.395.581-.955.811-1.396.717-.253 1.551-.475 2.33-.618.509.39 1.322.896 1.972.896 1.239.001 1.417-1.538.021-1.743zm-.104.704c-.2-.03-.488-.03-.829-.002.235.158.558.323.911.33.412.008.377-.26-.082-.328z" />
                    </svg>
                    Download setup instructions
                </a>
            </div>}
            <div className='my-4 mx-auto text-center'>
                <p>Visit our <a href="http://help.aronium.com" target="_blank" rel="noreferrer">support center</a> for tutorials and more information.</p>
                <p>If you have any questions, feel free to <a href='/contact'>contact us</a> anytime.</p>
            </div>
        </section>
    };
}

export default ThankYou;